var _rect, _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiteriaIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 4.50244,
    width: 27.0112,
    height: 4.50187,
    rx: 1.5,
    stroke: "#6A50FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0056 27.0109H7.50125C5.84371 27.0109 4.5 25.6672 4.5 24.0097V9.00342H28.51",
    stroke: "#6A50FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.0062H18.0031",
    stroke: "#6A50FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 19.5086H13.5012",
    stroke: "#6A50FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8603,
    cy: 15.0063,
    r: 2.25094,
    stroke: "#6A50FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8079 33.0134H28.2089C28.6139 33.0379 29.0099 32.8877 29.2968 32.6008C29.5837 32.3139 29.7339 31.9178 29.7095 31.5128V28.0614L31.2101 26.2606C31.3765 25.9869 31.4791 25.6791 31.5102 25.3603V22.5091C31.5347 22.1041 31.3845 21.708 31.0976 21.4211C30.8107 21.1342 30.4146 20.984 30.0096 21.0084H24.0071C23.6021 20.984 23.2061 21.1342 22.9192 21.4211C22.6323 21.708 22.482 22.1041 22.5065 22.5091V25.3603C22.5376 25.6791 22.6402 25.9869 22.8066 26.2606L24.3072 28.0614V31.5128C24.2828 31.9178 24.433 32.3139 24.7199 32.6008C25.0068 32.8877 25.4029 33.0379 25.8079 33.0134V33.0134Z",
    stroke: "#6A50FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiteriaIcon2);
export default __webpack_public_path__ + "static/media/сriteria-icon-2.46a5cf586dedcae6a46997b04f41d324.svg";
export { ForwardRef as ReactComponent };